export const login = (token, user_type, email, game_id) => {
  return {
    type: "LOGIN",
    payload: {
      token,
      user_type,
      email,
      game_id
    },
  };
};

export const logout = () => {
  return {
    type: "LOGOUT",
  };
};

export const updateUser = (email) => {
  return {
    type: "UPDATE_USER",
    email,
  };
};

export const setAuthenticatedNull = () => {
  return {
    type: "SET_AUTHENTICATED_NULL",
  };
};

export const setAuthenticatedFalse = () => {
  return {
    type: "SET_AUTHENTICATED_FALSE",
  };
};

export const setSessionEnded = () => {
  return {
    type: "SET_SESSION_ENDED",
  };
};

export const setActiveGameId = (activeGameId) => {
  return {
    type: "SET_ACTIVE_GAME_ID",
    activeGameId,
  };
};

export const resetActiveGameId = () => {
  return {
    type: "RESET_ACTIVE_GAME_ID",
  };
};

export const setActiveEvent = (activeEvent) => { //bool true or false, used in menu to hide game manager option
  return {
    type: "SET_ACTIVE_EVENT",
    activeEvent,
  };
}